import * as React from "react";
import styled from "styled-components";
import { LoginForm } from "../components/LoginForm";

export default function SignInPage() {
  return (
    <LoginContainer>
      <LoginWrapper>
        <LoginForm />
      </LoginWrapper>
    </LoginContainer>
  );
}

const LoginContainer = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: center;
  padding: 100px 80px 417px;
  @media (max-width: 991px) {
    padding: 100px 20px;
  }
`;

const LoginWrapper = styled.div`
  display: flex;
  width: 226px;
  max-width: 100%;
  flex-direction: column;
`;